import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { CheckoutGuard } from './core/guards/checkout.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'buy-ticket',
    loadChildren: () => import('./pages/buy-ticket/buy-ticket.module').then( m => m.BuyTicketPageModule)
  },
  {
    path: 'timetable',
    loadChildren: () => import('./pages/timetable/timetable.module').then( m => m.TimetablePageModule)
  },
  {
    path: 'tickets',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/tickets/tickets.module').then( m => m.TicketsPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'receipt',
    loadChildren: () => import('./pages/receipt/receipt.module').then( m => m.ReceiptPageModule)
  },
  {
    path: 'checkout',
    canActivate: [CheckoutGuard],
    loadChildren: () => import('./pages/checkout/checkout.module').then( m => m.CheckoutPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'order-history',
    loadChildren: () => import('./pages/order-history/order-history.module').then( m => m.OrderHistoryPageModule)
  },
  {
    path: 'klarna-confirmation',
    loadChildren: () => import('./pages/klarna-confirmation-page/klarna-confirmation.module').then( m => m.KlarnaConfirmationPageModule)
  },
  {
    path: 'klarna-checkout',
    loadChildren: () => import('./pages/klarna-checkout/klarna-checkout.module').then( m => m.KlarnaCheckoutPageModule)
  },
  {
    path: 'situations',
    loadChildren: () => import('./pages/situations/situations.module').then( m => m.SituationsPageModule)
  },
  {
    path: 'my-account',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/my-account/my-account.module').then( m => m.MyAccountPageModule)
  },
  {
    path: 'phone-number-dialog',
    loadChildren: () => import('./pages/phone-number-dialog/phone-number-dialog.module').then( m => m.PhoneNumberDialogPageModule)
  },
  {
    path: 'svea-checkout/:clientOrderNumber',
    loadChildren: () => import('./pages/svea-checkout/svea-checkout.module').then( m => m.SveaCheckoutPageModule)
  },
  {
    path: 'svea-checkout/from-app/:clientOrderNumber',
    loadChildren: () => import('./pages/svea-checkout/svea-checkout.module').then( m => m.SveaCheckoutPageModule)
  },
  {
    path: 'svea-confirmation/:clientOrderNumber',
    loadChildren: () => import('./pages/svea-confirmation-page/svea-confirmation.module').then( m => m.SveaConfirmationPageModule)
  },
  {
    path: 'svea-confirmation/from-app/:clientOrderNumber',
    loadChildren: () => import('./pages/svea-confirmation-page/svea-confirmation.module').then( m => m.SveaConfirmationPageModule)
  },


  // {
  //   path: 'terms',
  //   loadChildren: () => import('./pages/terms/terms.module').then( m => m.TermsPageModule)
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
